import { colors } from '../../Colors/colors'

export const assignFriendTheme = {
   light: {
      titleColor: 'text-gray-700',
      assignAFriend: {
         modalBg: 'bg-white',
         modalShadow: 'shadow-lg',
         iconContainerBg: 'bg-gray-100',
         titleColor: 'text-gray-900',
         descriptionColor: 'text-gray-600',
         separatorColor: 'border-gray-200'
      }
   },
   dark: {}
}
